import type { ReactNode } from 'react'
import { TextSmall } from '@/components/ui/Text'
import css from './Badge.module.css'

interface BadgeProps {
    children: ReactNode
}

const Badge = ({ children }: BadgeProps) => {
    return (
        <span className={css.badge}>
            <TextSmall>{children}</TextSmall>
        </span>
    )
}

export default Badge
